<script>
import CasesCommonHeadMobile from "@/components/mobile/案例/CasesCommonHeadMobile.vue";
import NextCaseButtonMobile from "@/components/mobile/案例/NextCaseButtonMobile.vue";

export default {
  name: "MobileHollySys",
  components: {NextCaseButtonMobile, CasesCommonHeadMobile}
}
</script>

<template>
  <div class="MobileHollySys">
    <CasesCommonHeadMobile :use-pic="true" :picurl="require('@/assets/picture/案例/和利时/移动端Banner.png')" :arrow-url="require('@/assets/anime/案例首页线条-蓝绿色.mp4')" :title-color="'#4069C3'">
      <template #headerTitle>工业自动化设备的数字化创新</template>
      <template #headerSlogan>交互设计｜界面设计｜3D渲染</template>
      <template #title1>成果</template>
      <template #content1>通过这样的可视化设计，我们大大简化后厨员工的操作流程，并提高他们的工作效率和准确性；并且减少了培训成本。</template>
      <template #title2>背景</template>
      <template #content2>和利时自动配锅机是一种先进的自动化设备，用于在后厨环境中进配置锅底底料的工作。这种设备具有电气控制屏和订单操作屏，但之前并未做过设计，而本次项目旨在为后厨的员工提供更好的使用体验和操作便利性。</template>
    </CasesCommonHeadMobile>
    <div class="HollySysCustom">
      <div class="Container1">
        <div class="Pic Pic1"></div>
        <div class="Pic Pic2"></div>
      </div>
      <div class="Container2">
        <div class="Content">
          <div class="Title3">“3D可视化<br>提升员工操作体验”</div>
          <div class="Text3">在设备的3D可视化界面中，操作人员可以清楚地看到设备的整体结构和各个操作区域的位置。通过精细的3D模型渲染，每个操作区域都被准确地呈现出来，并用独特的标识和高亮效果突出显示。</div>
        </div>
        <div class="Pic Pic3"></div>
      </div>
      <div class="Container3">
        <div class="Content">
          <div class="Title4">“3D可视化<br>提升员工操作体验”</div>
          <div class="Text4">在设备的3D可视化界面中，操作人员可以清楚地看到设备的整体结构和各个操作区域的位置。通过精细的3D模型渲染，每个操作区域都被准确地呈现出来，并用独特的标识和高亮效果突出显示。</div>
        </div>
        <div class="Pic Pic4"></div>
      </div>
      <div class="Container4">
        <div class="Content">
          <div class="Title5">“亮暗主题应对复杂的<br>后厨灯光环境”</div>
          <div class="Text5">为了应对复杂的后厨灯光环境，我们采用了亮暗双主题的设计概念，以确保设备的可视化界面在不同光线条件下都能清晰可见和易于操作。</div>
        </div>
        <div class="Pic Pic5"></div>
      </div>
      <div class="NextContainer">
        <router-link to="/mobileCase/case001"><NextCaseButtonMobile></NextCaseButtonMobile></router-link>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@use "@/global.scss" as global;

@mixin flex {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
@mixin picbox{
  border-radius: 12px;
  background: {
    repeat: no-repeat;
    size: cover;
    position: center;
  };
}
@mixin margin{
  margin-top: calc(32vw / 3.93);
  margin-bottom: calc(32vw / 3.93);
}
@mixin titleColor{
  color: #4069C3;
}

.Pic {
  @include picbox;
}

.MobileHollySys {
  width: 100vw;
  height: auto;
  .HollySysCustom {
    width: 100%;
    height: auto;
    padding-left: 4%;
    padding-right: 4%;
    @include flex;
    .Container1 {
      width: 100%;
      height: calc(172vw / 3.93);
      margin-bottom: calc(32vw / 3.93);
      @include flex;
      flex-direction: row;
      .Pic {
        width: calc(172vw / 3.93);
        height: 100%;
      }
      .Pic1 {
        background-image: url("@/assets/picture/案例/和利时/和利时02.png");
      }
      .Pic2 {
        background-image: url("@/assets/picture/案例/和利时/和利时03.png");
      }
    }
    .Container2 {
      width: 100%;
      height: calc(385vw / 3.93);
      @include margin;
      @include flex;
      .Content {
        width: 100%;
        min-height: calc(112vw / 3.93);
        @include flex;
        flex-direction: row;
        .Title3 {
          width: 40%;
          height: 100%;
          @include global.h4-vw-m;
          @include titleColor;
        }
        .Text3 {
          width: 50%;
          height: 100%;
          @include global.content-vw-m;
        }
      }
      .Pic3 {
        width: 100%;
        height: calc(233vw / 3.93);
        background-image: url("@/assets/picture/案例/和利时/和利时04.png");
      }
    }
    .Container3 {
      width: 100%;
      height: calc(350vw / 3.93);
      @include margin;
      @include flex;
      .Content {
        width: 100%;
        min-height: calc(96vw / 3.93);
        @include flex;
        flex-direction: row;
        .Title4 {
          width: 45%;
          height: 100%;
          @include global.h4-vw-m;
          @include titleColor;
        }
        .Text4 {
          width: 50%;
          height: 100%;
          @include global.content-vw-m;
        }
      }
      .Pic4 {
        width: 100%;
        height: calc(214vw / 3.93);
        background-image: url("@/assets/picture/案例/和利时/和利时05-移动端.png");
      }
    }
    .Container4 {
      width: 100%;
      height: calc(295vw / 3.93);
      @include margin;
      @include flex;
      .Content {
        width: 100%;
        min-height: calc(80vw / 3.93);
        @include flex;
        flex-direction: row;
        .Title5 {
          width: 45%;
          height: 100%;
          @include global.h4-vw-m;
          @include titleColor;
        }
        .Text5 {
          width: 50%;
          height: 100%;
          @include global.content-vw-m;
        }
      }
      .Pic5 {
        width: 100%;
        height: calc(175vw / 3.93);
        background-image: url("@/assets/picture/案例/和利时/和利时07.png");
      }
    }
    .NextContainer {
      width: 100%;
      height: calc(44vw / 3.93);
      padding-left: 17%;
      padding-right: 17%;
      margin-top: calc(64vw / 3.93);
      margin-bottom: calc(64vw / 3.93);
    }
  }
}
</style>